import { QueryClient } from "@tanstack/react-query";
import flagsmith from "flagsmith";
import { NavigateFunction } from "react-router-dom";

export const logoutSuccessCallback = (
  queryClient: QueryClient,
  navigate: NavigateFunction,
  timeout?: boolean,
  addRedirect?: boolean,
) => {
  queryClient.removeQueries();
  localStorage.clear();
  flagsmith.logout();

  const loginUrl = "/auth/login";
  const params = new URLSearchParams();

  if (timeout) {
    params.append("auth_message", "session_timeout");
  }

  if (addRedirect) {
    const currentPath = location.pathname + location.search;
    params.append("redirect", currentPath);
  }

  const queryString = params.toString();

  navigate({ pathname: loginUrl, search: queryString});
};

export const getJWTForAccountSuccessCallback = (
  queryClient: QueryClient,
  navigate: () => void,
) => {
  queryClient.removeQueries();
  navigate();
};
